import * as styles from "./DrawerViewport.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";

import type { DrawerViewportProps } from "./Drawer.types";

export function DrawerViewport({
  className,
  ...props
}: DrawerViewportProps): JSX.Element {
  return (
    <BaseDrawer.Viewport
      data-slot="drawer-viewport"
      className={clsx(styles.viewport, className)}
      {...props}
    />
  );
}
